enum SurveyItemType {
  Category = "Category",
  Asset = "Asset",
}

export default SurveyItemType;
